import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-list-corporate-models',
  templateUrl: './list-corporate-models.component.html',
  styleUrls: ['./list-corporate-models.component.css']
})
export class ListCorporateModelsComponent implements OnInit {
  modelsForm = new FormGroup({
    model: new FormControl(),
  });
  constructor(    
    @Inject(MAT_DIALOG_DATA) public data: Array<any>,
    private dialogRef: MatDialogRef<ListCorporateModelsComponent>,
  ) { }

  ngOnInit(): void {

  }

  onSubmit(): void {
    this.dialogRef.close(this.data.find(v => v.id == this.modelsForm.get('model').value));
  }
}
